module.exports = __webpack_public_path__ + "media/proksee-viewer/images/fb-bookmark-cf07a1f97c7a84e87d1502bd64b30cdf.svg";